/**
 * Opens a base64-encoded PDF in a new browser tab
 *
 * @param base64Data - Base64 string of PDF data (without data URL prefix)
 * @throws {Error} If base64 decoding or blob creation fails (caught and logged)
 *
 * @example
 * ```ts
 * handleOpenPdf("JVBERi0xLjQKJeLjz9M..."); // Base64 PDF data
 * ```
 */
export const handleOpenPdf = (base64Data: string) => {
  try {
    const binaryString = atob(base64Data);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");

    // Clean up blob URL after 100ms (industry standard delay)
    // Immediate revocation would make the URL invalid before the browser processes it
    // This timing gives the browser adequate time to handle the window.open() operation
    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
  } catch (error) {
    console.error("Failed to open PDF:", error);
  }
};
